import { put } from "redux-saga/effects";

import * as actions from "../../actions/forms";

export function* putNewForm(dataPath: string, fields: any) {

    yield put(actions.changeValue(dataPath, fields));
}